// export function categorizeScore(category) {
//   switch (category.abbreviation) {
//     case "PHQ": // Patient Health Questionnaire
//       if (category.score <= 4) return "Minimal";
//       if (category.score <= 9) return "Mild";
//       if (category.score <= 14) return "Moderate";
//       if (category.score <= 19) return "Moderately Severe";
//       return "Severe";

//     case "GAD": // Generalized Anxiety Disorder
//       if (category.score <= 4) return "Minimal";
//       if (category.score <= 9) return "Mild";
//       if (category.score <= 14) return "Moderate";
//       return "Severe";

//     case "AUDIT": // Alcohol Use
//       if (category.score <= 7) return "Low Risk";
//       if (category.score <= 15) return "Moderate Risk";
//       return "High Risk";

//     case "DAST": // Drug Abuse
//       if (category.score === 0) return "No Problems Reported";
//       if (category.score <= 2) return "Low";
//       if (category.score <= 6) return "Moderate";
//       return "Substantial";

//     case "CSSRS": // Suicide Risk
//       if (category.score <= 1) return "Low Risk";
//       if (category.score <= 3) return "Moderate Risk";
//       return "High Risk";

//     case "PTSD": // Post-Traumatic Stress Disorder
//       if (category.score <= 20) return "Minimal";
//       if (category.score <= 40) return "Mild";
//       if (category.score <= 60) return "Moderate";
//       return "Severe";

//     case "SLEEP": // Sleep Quality
//       if (category.score <= 4) return "Good Quality";
//       if (category.score <= 9) return "Moderate Disturbance";
//       return "Poor Quality";

//     case "MDQ": // Mood Disorders
//       if (category.score <= 6) return "Low Risk";
//       if (category.score <= 12) return "Moderate Risk";
//       return "High Risk";

//     case "FMMSE": // Mini-Mental State
//       if (category.score >= 27) return "Normal";
//       if (category.score >= 24) return "Mild Impairment";
//       if (category.score >= 18) return "Moderate Impairment";
//       return "Severe Impairment";

//     case "PRIME": // Psychosis Risk
//       if (category.score <= 5) return "Low Risk";
//       if (category.score <= 10) return "Moderate Risk";
//       return "High Risk";

//     case category?.scoringRange?.abbreviation:
//       for (const element of category.scoringRange.ranges) {
//         if (
//           category.score >= Number(element.rangeStart) &&
//           category.score < Number(element.rangeEnd)
//         ) {
//           return element.interpretation;
//         }
//       }
//       break;

//     default:
//       return "Unspecified";
//   }
// }

// export function customColor(category) {
//   switch (category.abbreviation) {
//     case category?.scoringRange?.abbreviation:
//       for (const element of category.scoringRange.ranges) {
//         if (
//           category.score >= Number(element.rangeStart) &&
//           category.score < Number(element.rangeEnd)
//         ) {
//           return element.color;
//         }
//       }
//       break;

//     default:
//       return;
//   }
// }

// export function severityColor(severity) {
//   switch (severity) {
//     case "Minimal":
//     case "Good Quality":
//     case "Normal":
//     case "Low Risk":
//     case "Low":
//     case "No Problems Reported":
//       return "bg-green-100";
//     case "Mild":
//     case "Moderate Disturbance":
//       return "bg-yellow-100";
//     case "Moderate":
//     case "Moderate Risk":
//     case "Mild Impairment":
//       return "bg-orange-100";
//     case "Moderately Severe":
//     case "Substantial":
//     case "High Risk":
//     case "Severe":
//     case "Poor Quality":
//     case "Severe Impairment":
//       return "bg-red-100";

//     default:
//       return "bg-gray-50";
//   }
// }
// export function interpretCompositeScore(score) {
//   if (score <= 20) return "Overall minimal concern.";
//   if (score <= 40) return "Mild overall concerns.";
//   if (score <= 60) return "Moderate overall concerns.";
//   if (score <= 80) return "Moderately severe overall concerns.";
//   return "Severe overall concerns, consider immediate follow-up.";
// }

 
//just change

export function categorizeScore(category) {
  if (category?.scoringRange?.ranges?.length) {
    for (const element of category.scoringRange.ranges) {
      if (
        category.score >= Number(element.rangeStart) &&
        category.score < Number(element.rangeEnd)
      ) {
        return element.interpretation;
      }
    }
    return "Score out of defined range";
  }

  switch (category.abbreviation) {
    case "PHQ": 
      if (category.score <= 4) return "Minimal";
      if (category.score <= 9) return "Mild";
      if (category.score <= 14) return "Moderate";
      if (category.score <= 19) return "Moderately Severe";
      return "Severe";

    case "GAD":
      if (category.score <= 4) return "Minimal";
      if (category.score <= 9) return "Mild";
      if (category.score <= 14) return "Moderate";
      return "Severe";

    case "AUDIT":
      if (category.score <= 7) return "Low Risk";
      if (category.score <= 15) return "Moderate Risk";
      return "High Risk";

    case "DAST":
      if (category.score === 0) return "No Problems Reported";
      if (category.score <= 2) return "Low";
      if (category.score <= 6) return "Moderate";
      return "Substantial";

    case "CSSRS":
      if (category.score <= 1) return "Low Risk";
      if (category.score <= 3) return "Moderate Risk";
      return "High Risk";

    case "PTSD":
      if (category.score <= 20) return "Minimal";
      if (category.score <= 40) return "Mild";
      if (category.score <= 60) return "Moderate";
      return "Severe";

    case "SLEEP":
      if (category.score <= 4) return "Good Quality";
      if (category.score <= 9) return "Moderate Disturbance";
      return "Poor Quality";

    case "MDQ":
      if (category.score <= 6) return "Low Risk";
      if (category.score <= 12) return "Moderate Risk";
      return "High Risk";

    case "FMMSE":
      if (category.score >= 27) return "Normal";
      if (category.score >= 24) return "Mild Impairment";
      if (category.score >= 18) return "Moderate Impairment";
      return "Severe Impairment";

    case "PRIME":
      if (category.score <= 5) return "Low Risk";
      if (category.score <= 10) return "Moderate Risk";
      return "High Risk";

    default:
      if (category?.score !== undefined) {
        if (category.score <= 5) return "Low Concern";
        if (category.score <= 10) return "Mild Concern";
        if (category.score <= 15) return "Moderate Concern";
        return "High Concern";
      }
      return "Data Not Available";
  }
}

export function customColor(category) {
  if (category?.scoringRange?.ranges?.length) {
    for (const element of category.scoringRange.ranges) {
      if (
        category.score >= Number(element.rangeStart) &&
        category.score < Number(element.rangeEnd)
      ) {
        return element.color;
      }
    }
  }

  const severity = categorizeScore(category);
  return severityColor(severity);
}

export function severityColor(severity) {
  switch (severity) {
    case "Minimal":
    case "Good Quality":
    case "Normal":
    case "Low Risk":
    case "Low":
    case "No Problems Reported":
    case "Low Concern":
      return "bg-green-100";

    case "Mild":
    case "Moderate Disturbance":
    case "Mild Concern":
      return "bg-yellow-100";

    case "Moderate":
    case "Moderate Risk":
    case "Mild Impairment":
    case "Moderate Concern":
      return "bg-orange-100";

    case "Moderately Severe":
    case "Substantial":
    case "High Risk":
    case "Severe":
    case "Poor Quality":
    case "Severe Impairment":
    case "High Concern":
      return "bg-red-100";

    case "Score out of defined range":
      return "bg-purple-100";

    default:
      return "bg-gray-100"; 
  }
}

export function interpretCompositeScore(score) {
  if (score <= 20) return "Overall minimal concern.";
  if (score <= 40) return "Mild overall concerns.";
  if (score <= 60) return "Moderate overall concerns.";
  if (score <= 80) return "Moderately severe overall concerns.";
  return "Severe overall concerns, consider immediate follow-up.";
}
